<template>

<div class="progress">
    <div class="progress-value" v-if="total" :style="{width: width}" />
    <div class="progress-step" v-for="(item, index) in progress" :key="index" :class="{'is-active': item}" />
</div>

</template>

<script>

export default {

    props: ['total', 'value', 'progress'],

    computed: {
    
        width: function() {
        
            if (this.total && this.value) {
            
                return ((100 / this.total) * this.value).toString() + '%'
            
            } else {
            
                return '0%'
            
            }        
        
        }
    
    }

}

</script>

<style scoped>

.progress {
    height: 5px;
    width: 100%;
    display: flex;
    background-color: #BAD1EC;
}

.progress-value {
    height: 5px;
    background-color: #1867C0;
}

.progress-step {
    flex-grow: 1;
    flex-shrink: 0;
}

.progress-step.is-active {
    background-color: #1867C0;
}

</style>
